<!--
 * @Author: alex.dai
 * @Date: 2023-04-20 15:43:33
 * @LastEditors: alex.dai
 * @LastEditTime: 2023-04-20 15:59:09
 * @FilePath: /new-frontend/src/components/order/ManualOrder.vue
 * @Description:
-->
<template>
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :width="countType === 0?'500px':'800px'"
    :closable="false"
    :title="`补发`"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="130">
      <Row v-if="countType === 0">
        <Col :sm="24" :xs="24">
          <FormItem label="充值账户:" prop="account">
            <Input v-model.trim="handleForm.account" :disabled="countType === 0" placeholder="请输入"/>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="产品标识:" prop="agentCommodityId">
            <Input v-model.trim="handleForm.agentCommodityId" :disabled="countType === 0" placeholder="请输入"/>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="商户订单号:" prop="outTradeNo">
            <Input v-model.trim="handleForm.outTradeNo" :disabled="countType === 0" placeholder="请输入"/>
          </FormItem>
        </Col>
      </Row>
      <Row v-else>
        <Col :sm="24" :xs="24">
          <!--          :style="(item.nodeState !== 2?'color:#19be6b':'')"-->
          <div v-for="(item, index) in currentList" :key="index"
               style="margin: 10px 0; display: flex; align-items: center;">
            <template v-if="rollbackState === 0">
              <Icon type="md-remove" color="#000" size="20"/>
            </template>
            <template v-else-if="rollbackState === 1 && !item.rollback">
              <span class="rotate-element"><Icon type="ios-loading" color="#333" size="18"/></span>
            </template>
            <template v-if="item.rollback === 1">
              <Icon type="md-checkmark-circle-outline" color="#19be6b" size="20"/>
            </template>
            <template v-else-if="item.rollback === 2">
              <Tooltip :content="item.error">
                <Icon type="md-close-circle" color="#000" size="20"/>
              </Tooltip>
            </template>
            <span style="font-weight: 600; margin-left: 8px">{{ item.account }}</span> - {{ item.commodityNo }} -
            {{ item.commodityName }}
          </div>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submitForm">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'

export default {
  name: 'ManualOrder',
  data() {
    return {
      modal: false,
      loading: false,
      handleForm: {
        account: null,
        agentCommodityId: null,
        outTradeNo: null
      },
      itemIdList: [],
      agentComList: [],
      handleValidate: {
        name: [
          {required: true, whitespace: true, message: '请输入供应商名称', trigger: 'blur'}
        ]
      },
      countType: 0,
      currentList: [],
      rollbackState: 0
    }
  },
  computed: {},
  methods: {
    setTimeDateFmt(s) {
      return s < 10 ? '0' + s : s
    },
    createordernum() {
      const now = new Date()
      let month = now.getMonth() + 1
      let day = now.getDate()
      let hour = now.getHours()
      let minutes = now.getMinutes()
      let seconds = now.getSeconds()
      month = this.setTimeDateFmt(month)
      day = this.setTimeDateFmt(day)
      hour = this.setTimeDateFmt(hour)
      minutes = this.setTimeDateFmt(minutes)
      seconds = this.setTimeDateFmt(seconds)
      return now.getFullYear().toString() + month.toString() + day + hour + minutes + seconds + (Math.round(Math.random() * 1000000)).toString()
    },
    show(items) {
      this.modal = true
      this.countType = items.length === 1 ? 0 : 1
      this.itemIdList = []
      this.currentList = items
      debugger
      if (items.length === 1) {
        this.handleForm.account = items[0].account
        this.handleForm.outTradeNo = items[0].agentTradeNo
        this.handleForm.agentCommodityId = items[0].commodityNo
        this.itemIdList.push(items[0].id)
      } else {
        this.currentList = items
        let list = []
        items.forEach(e => {
          list.push(e.id)
        })
        this.itemIdList = list
      }
    },
    hide() {
      this.$refs['handleForm'].resetFields()
      this.loading = false
      this.modal = false
      this.rollbackState = 0
      this.currentList = []
    },
    async submit() {
      this.rollbackState = 1
      for (let i = 0; i < this.currentList.length; i++) {
        await this.delay(1000);
        let vm = this
        console.log(vm.currentList[i].rollback)
        if (i % 2 === 0) {
          vm.$set(vm.currentList[i], 'rollback', 2);
        } else {
          vm.$set(vm.currentList[i], 'rollback', 1);
        }
      }

    },
    submitForm() {
      // console.log('修改参数', this.handleForm)
      if (this.rollbackState === 1) {
        this.hide()
        return
      }
      let rollbackOrder = api.order.rollbackOrder
      this.loading = true
      this.rollbackState = 1
      let vm = this
      for (let i = 0; i < this.currentList.length; i++) {
        let item = vm.currentList[i];
        rollbackOrder([item.id]).then(res => {
          vm.$set(item, 'rollback', 1);
        }).catch(err => {
          vm.$set(item, 'rollback', 2);
          vm.$set(item, 'error', err);
        }).finally(() => {
          this.loading = false
        })
      }
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
}
</script>

<style>

/* 定义关键帧 */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 应用动画 */
.rotate-element {
  animation: rotate 1s linear infinite; /* 持续时间2秒，线性速度，无限次播放 */
}
</style>
